export interface Product {
  id: string;
  name: string;
  description: string;
  useCase: string;
  image: string;
  category: string;
  isNew?: boolean;
  isFeatured?: boolean;
}

export const productCategories = [
  { id: 'ceramic',   label: 'Ceramic Coatings',   anchor: 'ceramic-coatings'   },
  { id: 'specialty', label: 'Specialty Coatings',  anchor: 'specialty-coatings' },
  { id: 'lpf',       label: 'Liquid PPF',          anchor: 'liquid-ppf'         },
  { id: 'color-ppf', label: 'Color Change PPF',    anchor: 'color-change-ppf'   },
  { id: 'tint',      label: 'Window Tint',         anchor: 'window-tint'        },
  { id: 'marine',    label: 'Marine Coatings',     anchor: 'marine-coatings'    },
];

export const products: Product[] = [

  // ── CERAMIC COATINGS ──────────────────────────────────────────────────────
  {
    id: 'ceramic-plus-10h',
    name: 'Ceramic Plus 10H Radical™',
    description: 'Professional-grade 10H hardness ceramic coating delivering maximum scratch resistance, deep gloss enhancement, and permanent hydrophobic surface protection. Engineered for professional installers demanding the highest performance ceiling.',
    useCase: 'Automotive exterior — all paint types',
    image: 'https://public.readdy.ai/ai/img_res/153046ddc3bdd45a3a746310488f31c6.jpg',
    category: 'ceramic',
    isFeatured: true,
  },
  {
    id: 'borograph-3-stealth',
    name: 'BOROGRAPH 3.0 "Stealth" CERAMIC COATING',
    description: 'The Stealth edition of the Borograph 3.0 line — self-leveling formula with 95% leveling performance. Permanent protection at a single layer of application with a deep, dark gloss finish engineered for high-end automotive surfaces.',
    useCase: 'High-end automotive · Specialty surfaces',
    image: 'https://readdy.ai/api/search-image?query=borograph-stealth-ceramic-coating-dark-bottle-product-shot-black-background-premium-automotive-coating-studio-dramatic-lighting-luxury-packaging&width=600&height=700&seq=borograph-3-stealth&orientation=portrait',
    category: 'ceramic',
    isFeatured: true,
  },
  {
    id: 'borophene-3',
    name: 'Borophene 3.0',
    description: 'NANOPRO® is the ONLY manufacturer of TRUE Borophene ceramic coatings — USPTO registered. Borophene 3.0 delivers state-of-the-art surface protection for automotive, marine, aviation, and residential applications.',
    useCase: 'Automotive · Marine · Aviation · Residential',
    image: 'https://readdy.ai/api/search-image?query=borophene-ceramic-coating-product-bottle-dark-studio-background-premium-automotive-protection-glossy-surface-professional-packaging-clean&width=600&height=700&seq=borophene-3&orientation=portrait',
    category: 'ceramic',
    isFeatured: true,
  },
  {
    id: 'borophene-4-grand-master',
    name: 'Borophene 4.0 GRAND MASTER',
    description: 'The pinnacle of the Borophene line. GRAND MASTER delivers the most advanced Borophene ceramic formulation available — permanent bond, maximum gloss index, and unmatched surface hardness for the most demanding professional applications.',
    useCase: 'Automotive · Marine · Aviation · Residential',
    image: 'https://readdy.ai/api/search-image?query=grand-master-premium-ceramic-coating-bottle-dark-luxury-background-gold-accents-automotive-protection-professional-studio-lighting-high-end-packaging&width=600&height=700&seq=borophene-4-gm&orientation=portrait',
    category: 'ceramic',
    isFeatured: true,
  },
  {
    id: 'refresh-hydrophobic',
    name: 'REFRESH™ - Hydrophobic Spray for Cars',
    description: 'A fast-application hydrophobic spray delivering instant water-beading performance and surface refresh. Ideal for maintaining ceramic-coated vehicles between full coating applications.',
    useCase: 'Automotive maintenance · Ceramic top-up',
    image: 'https://readdy.ai/api/search-image?query=hydrophobic-spray-bottle-product-shot-dark-background-water-beading-car-surface-automotive-maintenance-spray-clean-studio-lighting&width=600&height=700&seq=refresh-hydrophobic&orientation=portrait',
    category: 'ceramic',
  },
  {
    id: 'rv-gelcoat',
    name: 'Ceramic Coating For RV Gelcoat - 50 ML Sio3 Ceramic Coating',
    description: 'SiO3-based ceramic coating formulated specifically for RV gelcoat surfaces. Provides UV protection, hydrophobic performance, and long-term gloss retention for recreational vehicles exposed to the elements.',
    useCase: 'RV · Motorhome · Gelcoat surfaces',
    image: 'https://readdy.ai/api/search-image?query=rv-ceramic-coating-product-bottle-dark-background-recreational-vehicle-gelcoat-protection-studio-lighting-clean-minimal-packaging&width=600&height=700&seq=rv-gelcoat&orientation=portrait',
    category: 'ceramic',
  },

  // ── SPECIALTY COATINGS ────────────────────────────────────────────────────
  {
    id: 'black-pearl',
    name: 'Black Pearl Ceramic Coating',
    description: 'Formulated to amplify deep, dark paint tones with an intense wet-gloss appearance. Black Pearl enhances depth and clarity while providing permanent ceramic surface protection for dark and black automotive paint.',
    useCase: 'Dark & black automotive paint',
    image: 'https://readdy.ai/api/search-image?query=black-pearl-ceramic-coating-dark-bottle-product-shot-black-background-deep-gloss-automotive-dark-paint-premium-studio-lighting&width=600&height=700&seq=black-pearl&orientation=portrait',
    category: 'specialty',
    isFeatured: true,
  },
  {
    id: 'soft-fabric-sio3',
    name: 'Soft Fabric Sio3™ Ceramic Coating - Car Interior (50mL)',
    description: 'SiO3 ceramic coating engineered for soft fabric and textile surfaces inside the vehicle. Provides stain resistance, hydrophobic protection, and long-term durability for car seats, headliners, and fabric panels.',
    useCase: 'Car interior fabric · Seats · Headliners',
    image: 'https://readdy.ai/api/search-image?query=fabric-ceramic-coating-product-bottle-dark-background-car-interior-textile-protection-studio-lighting-clean-minimal-packaging&width=600&height=700&seq=soft-fabric-sio3&orientation=portrait',
    category: 'specialty',
  },
  {
    id: 'matte-plus',
    name: 'Matte Plus Ceramic Coating for Satin & Matte',
    description: 'Engineered specifically for satin and matte paint finishes. Preserves the flat aesthetic while delivering full ceramic-grade hydrophobic protection and durability without any gloss enhancement.',
    useCase: 'Matte & satin automotive paint finishes',
    image: 'https://readdy.ai/api/search-image?query=matte-ceramic-coating-product-bottle-dark-background-satin-matte-automotive-paint-protection-studio-lighting-clean-minimal&width=600&height=700&seq=matte-plus&orientation=portrait',
    category: 'specialty',
  },
  {
    id: 'solar-charge',
    name: 'Nanopro® "SOLAR CHARGE" CERAMIC COATING VERSION',
    description: 'Part of the exclusive Solar Charge series — advanced ceramic coating with luminescent properties. Glow-in-the-dark performance coating engineered for specialty automotive and decorative surface applications.',
    useCase: 'Specialty automotive · Decorative surfaces',
    image: 'https://readdy.ai/api/search-image?query=solar-charge-glow-ceramic-coating-product-bottle-dark-background-luminescent-specialty-automotive-studio-lighting-premium-packaging&width=600&height=700&seq=solar-charge&orientation=portrait',
    category: 'specialty',
  },
  {
    id: 'carpet-magic',
    name: 'Carpet Magic E-Z Spray™ on Application',
    description: 'Easy spray-on ceramic protection for automotive carpet and floor surfaces. Delivers stain resistance, hydrophobic performance, and long-term durability with a simple E-Z Spray application process.',
    useCase: 'Automotive carpet · Floor surfaces',
    image: 'https://readdy.ai/api/search-image?query=carpet-spray-ceramic-coating-product-bottle-dark-background-automotive-interior-floor-protection-studio-lighting-clean-packaging&width=600&height=700&seq=carpet-magic&orientation=portrait',
    category: 'specialty',
  },
  {
    id: 'wheel-caliper',
    name: 'Ceramic Coating for Wheels (Wheel & Caliper™ Ceramic Coating) - 50 mL',
    description: 'Purpose-built ceramic coating for wheels and brake calipers. Withstands extreme heat, brake dust, and road contamination while delivering a permanent hydrophobic bond and lasting gloss on all wheel finishes.',
    useCase: 'Wheels · Brake calipers · Alloy surfaces',
    image: 'https://readdy.ai/api/search-image?query=wheel-caliper-ceramic-coating-product-bottle-dark-background-automotive-wheel-protection-brake-caliper-studio-lighting-clean&width=600&height=700&seq=wheel-caliper&orientation=portrait',
    category: 'specialty',
  },
  {
    id: 'nanoflex-tire',
    name: 'Nanoflex™ Plastic & Rubber™ (Tire) Ceramic Coating for Cars',
    description: 'Flexible ceramic coating engineered for rubber tires, plastic trim, and exterior plastic components. Restores deep black tone, prevents fading, and provides durable hydrophobic surface protection.',
    useCase: 'Tires · Rubber · Plastic trim',
    image: 'https://readdy.ai/api/search-image?query=tire-rubber-ceramic-coating-product-bottle-dark-background-automotive-plastic-trim-protection-studio-lighting-clean-minimal&width=600&height=700&seq=nanoflex-tire&orientation=portrait',
    category: 'specialty',
  },
  {
    id: 'ez-glass',
    name: 'EZ Glass™ - Ceramic Coating for Glass',
    description: 'Precision-formulated ceramic coating for glass surfaces. Delivers hydrophobic rain-repelling performance, UV clarity, and long-term adhesion to automotive and architectural glass.',
    useCase: 'Automotive glass · Architectural glass',
    image: 'https://readdy.ai/api/search-image?query=glass-ceramic-coating-product-bottle-dark-background-automotive-windshield-glass-protection-hydrophobic-studio-lighting-clean&width=600&height=700&seq=ez-glass&orientation=portrait',
    category: 'specialty',
  },
  {
    id: 'everything-leather',
    name: 'Everything Leather™ - Interior Ceramic Coating',
    description: 'Interior ceramic coating formulated for all leather surfaces. Provides UV protection, stain resistance, and a lasting hydrophobic bond that preserves the natural feel and appearance of leather seats and panels.',
    useCase: 'Leather seats · Interior panels · Steering wheels',
    image: 'https://readdy.ai/api/search-image?query=leather-ceramic-coating-product-bottle-dark-background-car-interior-leather-protection-studio-lighting-clean-minimal-packaging&width=600&height=700&seq=everything-leather&orientation=portrait',
    category: 'specialty',
  },
  {
    id: 'ceramic-soap',
    name: 'Ceramic Soap™ - The Advance Ceramic Coating Solutions - 8 oz',
    description: 'Advanced ceramic coating soap formulated to clean and maintain ceramic-coated surfaces. Enhances hydrophobic performance, removes contaminants, and preserves the integrity of existing ceramic coatings.',
    useCase: 'Ceramic-coated vehicle maintenance',
    image: 'https://readdy.ai/api/search-image?query=ceramic-soap-product-bottle-dark-background-automotive-wash-maintenance-studio-lighting-clean-minimal-packaging-premium&width=600&height=700&seq=ceramic-soap&orientation=portrait',
    category: 'specialty',
  },
  {
    id: 'vinyl-convertible',
    name: 'Ceramic Coating for Vinyl Convertible™ Tops and Soft Canvas Tops E-Z Spray on Application',
    description: 'E-Z Spray ceramic coating engineered for vinyl convertible tops and soft canvas surfaces. Provides UV protection, water repellency, and long-term durability for convertible tops exposed to the elements.',
    useCase: 'Convertible tops · Vinyl · Soft canvas',
    image: 'https://readdy.ai/api/search-image?query=convertible-top-ceramic-coating-product-bottle-dark-background-vinyl-canvas-protection-studio-lighting-clean-minimal-packaging&width=600&height=700&seq=vinyl-convertible&orientation=portrait',
    category: 'specialty',
  },
  {
    id: 'clearpro',
    name: 'Nanopro® CLEARPRO- Hand Applied Clear coat',
    description: 'A hand-applied clearcoat solution providing a factory-fresh clear protective layer. Bridges paint correction and ceramic coating stages for optimal surface preparation and long-term gloss retention.',
    useCase: 'Pre-coating surface clearcoat application',
    image: 'https://readdy.ai/api/search-image?query=clearcoat-product-bottle-dark-background-automotive-paint-protection-hand-applied-studio-lighting-clean-minimal-packaging-premium&width=600&height=700&seq=clearpro&orientation=portrait',
    category: 'specialty',
  },

  // ── LIQUID PPF ────────────────────────────────────────────────────────────
  {
    id: 'lpf-accelerate',
    name: 'NANOPRO LIQUID PAINT PROTECTION FILM KIT (LPF ACCELERATE™)',
    description: 'One 120mL bottle completes a full vehicle or 2–3 full front ends. The only liquid paint protection film of its kind — no traditional installation process, no film removal. PPF-level paint protection available exclusively through NANOPRO® Certified Elite Detailers.',
    useCase: 'Automotive paint protection · PPF alternative',
    image: 'https://nanoproceramic.com/cdn/shop/files/88E2322A-5BC2-4A8E-BCE2-C9A45276B4B5_600x.jpg?v=1749840357',
    category: 'lpf',
    isNew: true,
    isFeatured: true,
  },

  // ── COLOR CHANGE PPF ──────────────────────────────────────────────────────
  {
    id: 'lpf-color-change',
    name: 'NANOPRO LIQUID PAINT PROTECTION FILM KIT Color Change',
    description: 'Liquid PPF with color change capability — apply paint protection and transform your vehicle\'s color simultaneously. Revolutionary approach to vehicle color transformation with PPF-level surface protection.',
    useCase: 'Color change · Paint protection',
    image: 'https://readdy.ai/api/search-image?query=color-change-liquid-ppf-product-kit-dark-background-automotive-color-transformation-paint-protection-studio-lighting-premium-packaging&width=600&height=700&seq=lpf-color-change&orientation=portrait',
    category: 'color-ppf',
    isNew: true,
    isFeatured: true,
  },
  {
    id: 'matte-lpf',
    name: 'NANOPRO® MATTE LPF - LIQUID PPF FOR MATTE/SATIN VEHICLE PAINTJOBS',
    description: 'Liquid paint protection film formulated for matte and satin vehicle paint jobs. Provides PPF-level protection while maintaining the original matte or satin finish without any gloss alteration.',
    useCase: 'Matte & satin vehicle protection',
    image: 'https://readdy.ai/api/search-image?query=matte-liquid-ppf-product-bottle-dark-background-satin-matte-vehicle-paint-protection-studio-lighting-clean-minimal-packaging&width=600&height=700&seq=matte-lpf&orientation=portrait',
    category: 'color-ppf',
    isNew: true,
  },

  // ── WINDOW TINT ───────────────────────────────────────────────────────────
  {
    id: 'wow-tint',
    name: 'MEDIUM - W.O.W. (WIPE ON WINDOW TINT) BY NANOPRO®',
    description: 'The industry\'s only hand-applied wipe-on window tint. Medium shade — wipe-on application with no traditional film installation process or film removal. Available only to Certified NanoPro® Installers.',
    useCase: 'Automotive & residential window tinting',
    image: 'https://nanoproceramic.com/cdn/shop/files/LIGHTWOW_540x.png?v=1772293772',
    category: 'tint',
    isNew: true,
    isFeatured: true,
  },

  // ── MARINE COATINGS ───────────────────────────────────────────────────────
  {
    id: 'nautilus-marine',
    name: 'Nautilus 250mL Marine Sio3™ Ceramic Coating - Ceramic Coating For Marine',
    description: 'Marine-grade SiO3 ceramic formulation in a 250mL professional size. Engineered for vessels exposed to saltwater, UV, and constant moisture. Delivers permanent hull protection, anti-fouling resistance, and sustained gloss for boats and watercraft.',
    useCase: 'Boats · Yachts · Marine vessels',
    image: 'https://readdy.ai/api/search-image?query=marine-ceramic-coating-product-bottle-dark-background-nautical-boat-hull-protection-saltwater-studio-lighting-premium-packaging-clean&width=600&height=700&seq=nautilus-marine&orientation=portrait',
    category: 'marine',
    isFeatured: true,
  },
  {
    id: 'wood-plus',
    name: 'Wood Plus™ Ceramic Coating',
    description: 'Ceramic coating formulated for wood surfaces — decks, trim, and marine woodwork. Provides UV protection, water repellency, and long-term surface integrity for wood exposed to outdoor and marine environments.',
    useCase: 'Wood decks · Marine woodwork · Outdoor wood',
    image: 'https://readdy.ai/api/search-image?query=wood-ceramic-coating-product-bottle-dark-background-wood-surface-protection-marine-outdoor-studio-lighting-clean-minimal-packaging&width=600&height=700&seq=wood-plus&orientation=portrait',
    category: 'marine',
  },
];
